import { Instagram, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import SectionHeading from "./SectionHeading";
import Curriculo from "./Curriculo";
import { FUNDADOR, EQUIPE, INSTAGRAM_URL } from "../data/siteData";

const Profissionais = () => (
  <section id="profissionais" data-testid="profissionais-section" className="relative bg-navy py-20 md:py-28">
    <div className="beam left-[30%] opacity-40" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Comissão técnica"
        title="Nossa Equipe"
        lead="Profissionais experientes dedicados ao desenvolvimento de cada atleta, dentro e fora de campo."
      />

      <Reveal className="mb-10">
        <article
          data-testid="founder-card"
          className="grid overflow-hidden rounded-3xl border border-gold/30 bg-gradient-to-br from-royal/50 to-night md:grid-cols-5"
        >
          <div className="relative md:col-span-2">
            <img
              src={FUNDADOR.foto}
              alt={`${FUNDADOR.nome}, ${FUNDADOR.cargo} da Soccer Trainer`}
              loading="lazy"
              className="h-80 w-full object-cover object-top md:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-night/80 via-transparent to-transparent md:bg-gradient-to-r" />
          </div>
          <div className="p-8 md:col-span-3 md:p-12">
            <span className="inline-flex items-center gap-2 rounded-full bg-gold/15 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-gold">
              <BadgeCheck size={14} /> Desde 2011
            </span>
            <h3 className="mt-5 font-display text-4xl uppercase tracking-wide text-white sm:text-5xl">
              {FUNDADOR.nome}
            </h3>
            <p className="mt-1 text-sm font-bold uppercase tracking-widest text-lawn">{FUNDADOR.cargo}</p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80">{FUNDADOR.bio}</p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-instagram-link"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white/70 transition-colors hover:text-gold"
            >
              <Instagram size={18} /> @soccertrainerpatos
            </a>
          </div>
        </article>
      </Reveal>

      <Curriculo />

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {EQUIPE.map((p, i) => (
          <Reveal key={p.foto || i} delay={i * 0.08}>
            <article
              data-testid={`staff-card-${i}`}
              className="group relative h-96 overflow-hidden rounded-2xl border border-white/10"
              tabIndex={0}
            >
              {p.foto ? (
                <img
                  src={p.foto}
                  alt={`${p.titulo} — Soccer Trainer`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-royal to-night">
                  <span className="font-display text-7xl text-lawn/60">ST</span>
                </div>
              )}
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-night via-night/80 to-transparent p-5 pt-14 transition-all duration-300 group-hover:via-night/95 group-focus-within:via-night/95">
                <h3 className="font-display text-2xl uppercase tracking-wide text-white">{p.titulo}</h3>
                {p.subtitulo && (
                  <p className="text-xs font-bold uppercase tracking-widest text-lawn">{p.subtitulo}</p>
                )}
                <div className="mt-3 max-h-0 overflow-hidden opacity-0 transition-all duration-500 group-hover:max-h-40 group-hover:opacity-100 group-focus-within:max-h-40 group-focus-within:opacity-100">
                  <p className="text-xs leading-relaxed text-white/75">{p.bio}</p>
                  <a
                    href={p.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`staff-instagram-${i}`}
                    aria-label={`Instagram — ${p.titulo}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-gold"
                  >
                    <Instagram size={15} /> Instagram
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Profissionais;
